import React from 'react';
import PropTypes from 'prop-types';

function capitalise(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
}

/**
 * Display an additional contamination message.
 *
 * @function
 * @param       {object} item          print allergens button object
 * @constructor
 */
function PrintAllergensButton({ pdpInfo }) {
    return (
        <>
            <button
                style={{ padding: '5px', margin: '5px' }}
                onClick={() => {
                    const printingWindow = window.open('', '', '');
                    printingWindow.document.write("<style type='css'>");
                    printingWindow.document.write('body { margin: 0 }');
                    printingWindow.document.write('</style>');
                    printingWindow.document.write(
                        "<div style='margin-left: 10px; margin-right: 10px; margin-top: 0; margin-bottom: 0'>"
                    );
                    printingWindow.document.write(
                        `<h2 style='margin: 0; font-size: 16px'><b>${pdpInfo.displayName}</b></h2>`
                    );
                    printingWindow.document.write(
                        "<h3 style='margin: 0; font-size: 14px'><b><u>Allergens in bold:</u></b></h3>"
                    );

                    pdpInfo.allergens
                        .filter((allergen) => allergen.present.trim() !== 'NO')
                        .forEach((allergen) => {
                            printingWindow.document.write(
                                `<p style='font-size: 12px'><b>${
                                    allergen.name
                                }</b>:<br/>${capitalise(
                                    allergen.present
                                        .replaceAll('_', ' ')
                                        .toLowerCase()
                                )}</p>`
                            );
                        });
                    printingWindow.document.write('</div>');
                    printingWindow.document.close();
                    printingWindow.focus();
                    printingWindow.print();
                    printingWindow.close();
                }}
            >
                Print allergen info
            </button>
        </>
    );
}

PrintAllergensButton.propTypes = {
    pdpInfo: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
};

export { PrintAllergensButton };
